import AppListing from '../app-components/Listing/AppListing';

Vue.component('document-group-listing', {
    mixins: [AppListing],
    data: function data() {
        return {
            orderBy: {
                column: 'title',
                direction: 'asc'
            },
            filters: {
                'position_id': '',
                'contract_type_id': '',
                'document_type_id': '',
            },
        };
    },
});


// WEBPACK FOOTER //
// ./resources/assets/admin/js/document-group/Listing.js